import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17bf5934"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "find" }
const _hoisted_2 = { class: "filters desktop-only" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "sort" }
const _hoisted_5 = { class: "search" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "section-header" }
const _hoisted_8 = { class: "primary-info" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tags" }, null, -1))
const _hoisted_10 = { class: "section-grid" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_14 = { class: "action desktop-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ShopifyImg = _resolveComponent("ShopifyImg")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              (!_ctx.jobId)
                ? (_openBlock(), _createBlock(_component_ion_menu_button, {
                    key: 0,
                    slot: "start"
                  }))
                : _createCommentVNode("", true),
              (_ctx.jobId)
                ? (_openBlock(), _createBlock(_component_ion_back_button, {
                    key: 1,
                    slot: "start",
                    onClick: _ctx.navigateBack,
                    "default-href": "/"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Create rule")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    fill: "clear",
                    class: "mobile-only"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.downloadOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    fill: "clear",
                    class: "mobile-only"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.filterOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  (_ctx.jobId && (_ctx.isFilterChanged || _ctx.threshold != _ctx.job?.runtimeData?.threshold))
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 0,
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            color: "warning",
                            icon: _ctx.warningOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("aside", _hoisted_2, [
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, { lines: "inset" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("Threshold")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        type: "number",
                        placeholder: _ctx.$t('global threshold'),
                        modelValue: _ctx.threshold,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.threshold) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_list_header, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Include")), 1),
                        _createVNode(_component_ion_button, {
                          fill: "clear",
                          color: "warning",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetFilters('included')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('reset')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("Tags")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_button, {
                            fill: "clear",
                            slot: "end",
                            size: "small",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchFilter('tags', 'tagsFacet', 'tags', 'included')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_icon, { icon: _ctx.addCircleOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("Operator")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            interface: "popover",
                            onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.applyOperator('included', 'tags', $event.detail.value))),
                            value: _ctx.appliedFilters['included']['tags'].operator
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "AND" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("AND")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "OR" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("OR")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedFilters['included']['tags'].list, (tag, index) => {
                            return (_openBlock(), _createBlock(_component_ion_chip, {
                              outline: true,
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.pricetagOutline }, null, 8, ["icon"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tag), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_icon, {
                                  icon: _ctx.closeCircle,
                                  onClick: ($event: any) => (_ctx.removeFilters('included', 'tags', tag))
                                }, null, 8, ["icon", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Exclude")), 1),
                        _createVNode(_component_ion_button, {
                          fill: "clear",
                          color: "warning",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetFilters('excluded')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('reset')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("Tags")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_button, {
                            fill: "clear",
                            slot: "end",
                            size: "small",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchFilter('tags', 'tagsFacet', 'tags', 'excluded')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_icon, { icon: _ctx.addCircleOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("Operator")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            onIonChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.applyOperator('excluded', 'tags', $event.detail.value))),
                            interface: "popover",
                            value: _ctx.appliedFilters['excluded']['tags'].operator
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "AND" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("AND")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "OR" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("OR")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedFilters['excluded']['tags'].list, (tag, index) => {
                            return (_openBlock(), _createBlock(_component_ion_chip, {
                              outline: true,
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.pricetagOutline }, null, 8, ["icon"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tag), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_icon, {
                                  icon: _ctx.closeCircle,
                                  onClick: ($event: any) => (_ctx.removeFilters('excluded', 'tags', tag))
                                }, null, 8, ["icon", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("main", _hoisted_3, [
              _createElementVNode("section", _hoisted_4, [
                _createVNode(_component_ion_item, { lines: "none" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Results")) + ": " + _toDisplayString(_ctx.products.total.virtual) + " " + _toDisplayString(_ctx.$t("virtual, ")) + " " + _toDisplayString(_ctx.products.total.variant) + " " + _toDisplayString(_ctx.$t("variants")), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("section", _hoisted_5, [
                  _createVNode(_component_ion_searchbar, {
                    placeholder: _ctx.$t('Check products'),
                    modelValue: _ctx.queryString,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.queryString) = $event)),
                    onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => {_ctx.queryString = $event.target.value; _ctx.searchProducts($event)}, ["enter"]))
                  }, null, 8, ["placeholder", "modelValue"])
                ])
              ]),
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products.list, (product) => {
                return (_openBlock(), _createElementBlock("div", { key: product }, [
                  _createElementVNode("section", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_ion_item, { lines: "none" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(product.productName) + " ", 1),
                              _createElementVNode("p", null, _toDisplayString(product.variants.length) + " " + _toDisplayString(_ctx.$t("variants")), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _hoisted_9
                  ]),
                  _createElementVNode("section", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.variants, (variant) => {
                      return (_openBlock(), _createElementBlock("div", { key: variant }, [
                        _createVNode(_component_ion_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ShopifyImg, {
                              src: variant.mainImageUrl
                            }, null, 8, ["src"]),
                            _createVNode(_component_ion_item, { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(variant.productName) + " ", 1),
                                    (variant.color)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t("Color")) + ": " + _toDisplayString(variant.color), 1))
                                      : _createCommentVNode("", true),
                                    (variant.size)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("Size")) + ": " + _toDisplayString(variant.size), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ]),
                  _hoisted_13
                ]))
              }), 128)),
              _createVNode(_component_ion_infinite_scroll, {
                onIonInfinite: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadMoreProducts($event))),
                threshold: "100px",
                disabled: !_ctx.isScrollable
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_infinite_scroll_content, {
                    "loading-spinner": "crescent",
                    "loading-text": _ctx.$t('Loading')
                  }, null, 8, ["loading-text"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.jobId)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 0,
                  disabled: !_ctx.hasPermission(_ctx.Actions.APP_THRESHOLD_RULE_UPDATE) || _ctx.isJobEditable() || _ctx.isServiceScheduling,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateThreshold()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      icon: _ctx.saveOutline
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("Update threshold rule")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : (_openBlock(), _createBlock(_component_ion_button, {
                  key: 1,
                  disabled: !_ctx.hasPermission(_ctx.Actions.APP_THRESHOLD_RULE_UPDATE),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.saveThreshold()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      icon: _ctx.saveOutline
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("Save threshold rule")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
          ]),
          _createVNode(_component_ion_fab, {
            vertical: "bottom",
            horizontal: "end",
            slot: "fixed",
            class: "mobile-only"
          }, {
            default: _withCtx(() => [
              (_ctx.jobId)
                ? (_openBlock(), _createBlock(_component_ion_fab_button, {
                    key: 0,
                    disabled: !_ctx.hasPermission(_ctx.Actions.APP_THRESHOLD_RULE_UPDATE) || _ctx.isServiceScheduling || _ctx.isJobEditable(),
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateThreshold()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.arrowForwardOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : (_openBlock(), _createBlock(_component_ion_fab_button, {
                    key: 1,
                    disabled: !_ctx.hasPermission(_ctx.Actions.APP_THRESHOLD_RULE_UPDATE),
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveThreshold()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.arrowForwardOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}